import type { VariantProps } from "class-variance-authority";
import { badgeVariants, supportedColors } from "./variants";

export type BadgeProps = VariantProps<typeof badgeVariants>;
export type BadgeColor = BadgeProps["color"];

export function isBadgeColor(color: unknown): color is BadgeColor {
  return typeof color === "string" && supportedColors.includes(color);
}

export function Badge({
  border = false,
  button = false,
  color = "zinc",
  className,
  rounded = false,
  transparent = false,
  ...props
}: BadgeProps & React.ComponentPropsWithoutRef<"span">) {
  return (
    <span
      role="status"
      {...props}
      className={badgeVariants({
        border,
        button,
        color,
        className,
        rounded,
        transparent,
      })}
    />
  );
}
